var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
export const SettingsTile = { title: 'Settings', key: 'settings' };
export class AdminViewStore {
    constructor() {
        this.activeTab = 'settings';
        this.gettingtasks = false;
        this.loadingbottomtasks = false;
        this.lasttasktime = new Date().getTime();
        this.recentasktime = 0;
        this.tasks = new Map();
        this.userid = "";
        makeObservable(this);
    }
    setUserid(userid) {
        this.userid = userid;
        this.getAssignedTasks(false);
    }
    setGettingTasks(getting) {
        this.gettingtasks = getting;
    }
    setLoadingBottomTask(loading) {
        this.loadingbottomtasks = loading;
    }
    setActiveTab(tab) {
        this.activeTab = tab;
    }
    reset() {
        this.activeTab = 'settings';
    }
    getAssignedTasks(reverse = false) {
        if (reverse && this.gettingtasks) {
            return;
        }
        if (!reverse && this.loadingbottomtasks) {
            return;
        }
        if (reverse) {
            this.setGettingTasks(true);
        }
        else {
            this.setLoadingBottomTask(true);
        }
        let time = this.lasttasktime;
        if (reverse) {
            time = this.recentasktime;
        }
        const req = {
            reverse: reverse,
            request: time,
            ignorids: Array.from(this.tasks.values()).filter((vl) => vl.updatetime === time).map((en) => en.id),
            letrid: "",
            count: reverse ? 10000 : 20,
            userid: this.userid
        };
        Apphandler.sendMessage("adminassignedtask", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], AdminViewStore.prototype, "activeTab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminViewStore.prototype, "gettingtasks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminViewStore.prototype, "loadingbottomtasks", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminViewStore.prototype, "tasks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminViewStore.prototype, "userid", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminViewStore.prototype, "setUserid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminViewStore.prototype, "setGettingTasks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminViewStore.prototype, "setLoadingBottomTask", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminViewStore.prototype, "setActiveTab", null);
